import { cn } from '@avanta/shared/utils/cn';

interface HeroBannerProps {
  image: string;
  alt: string;
  className?: string;
}

export const HeroBanner = ({ image, alt, className }: HeroBannerProps): React.ReactElement => (
  <div className={cn('w-full rounded-lg overflow-hidden max-am-lg:hidden', className)}>
    <img src={image} alt={alt} className="w-full object-cover" />
  </div>
);
